import React from "react";

export default () => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.77246 1.17676L16.0146 6.06055L15.7354 6.47461L15.4561 6.88965L14.5635 6.28711V15.1143H2.4209V6.28809L1.5293 6.88965L1.25 6.47461L0.970703 6.06055L8.21289 1.17676L8.49316 0.988281L8.77246 1.17676ZM3.4209 5.61426V14.1143H13.5635V5.61328L8.49316 2.19531L3.4209 5.61426Z"
            fill="#0049C6"
        />
        <line x1="3" y1="10.5" x2="14" y2="10.5" stroke="#0049C6" />
        <line x1="10.5" y1="6" x2="10.5" y2="11" stroke="#0049C6" />
        <line x1="7.5" y1="10" x2="7.5" y2="15" stroke="#0049C6" />
        <line x1="14" y1="6.51001" x2="3" y2="6.51001" stroke="#0049C6" />
    </svg>
);
